import React, { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import block from 'bem-cn';

import { useAppSelector } from 'shared/hooks';

import Item from './Item';

import './TableBalance.scss';

const b = block('balance-table-mobile');

const TableBalance = ({ data, type, setIsAsc, isAsc }) => {
  const locale = useAppSelector(state => state.locale.locale, shallowEqual);

  const itemsElements = useMemo(
    () =>
      data?.map((t, i) => (
        <div key={t.id} className={b('item')}>
          <Item item={t} type={type} setIsAsc={setIsAsc} isAsc={isAsc} />
        </div>
      )),
    [data, type, setIsAsc, isAsc],
  );

  return (
    <div className={b()}>
      {itemsElements?.length ? itemsElements : <div className={b('empty')}>{locale.noResultsFound}</div>}
    </div>
  );
};

export default TableBalance;
